import WsProvider from './provider/WSProvider'

var base64 = require('base64_js');
var userDataExon = localStorage.getItem("userDataExon") ? JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataExon")))) : "";

var serviceName = "index";
var hizmetService = {
    imageUrlBuyuk: WsProvider.resim + "/" + userDataExon["firmaKodu"] + "/buyuk/",
    imageUrlOrta: WsProvider.resim + "/" + userDataExon["firmaKodu"] + "/orta/",
    imageUrlKucuk: WsProvider.resim + "/" + userDataExon["firmaKodu"] + "/kucuk/",
    imageUrlEnKucuk: WsProvider.resim + "/" + userDataExon["firmaKodu"] + "/enkucuk/",
    path  : "https://www.exonbiyotek.com/",
    hizmetTanimlama(link, hkategoriId, baslik, altBaslik, icerik, resimList, resimKonum, menuKonum, galeriKonum, url, baslamaTarihi, bitisTarihi, sayac, begen, seoBaslik, seoIcerik,dil) {
        var userDataExon = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataExon"))));
        var param = {
            data: {
                yonetimId: userDataExon["yonetimId"],
                userToken: userDataExon["token"],
                firmaKodu: userDataExon["firmaKodu"],
                hkategoriId: hkategoriId,
                link: link,
                baslik: baslik,
                altBaslik: altBaslik,
                icerik: icerik,
                resimList: resimList,
                resimKonum: resimKonum,
                menuKonum: menuKonum,
                galeriKonum: galeriKonum,
                url: url,
                baslamaTarihi: baslamaTarihi,
                bitisTarihi: bitisTarihi,
                sayac: sayac,
                begen: begen,
                seoBaslik: seoBaslik,
                seoIcerik: seoIcerik,
                dil: dil,
                serviceName: "hizmet",
                methodName: "hizmetTanimlama"

            }
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },

    hizmetDetay(hizmetId) {
        var userDataExon = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataExon"))));
        var param = {
            data: {
                yonetimId: userDataExon["yonetimId"],
                userToken: userDataExon["token"],
                firmaKodu: userDataExon["firmaKodu"],
                hizmetId: hizmetId,
                dil: "",
                serviceName: "hizmet",
                methodName: "hizmetDetay"

            }
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },


    hizmetListesi(durum, baslangic, limit) {
        var userDataExon = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataExon"))));
        var param = {
            data: {
                yonetimId: userDataExon["yonetimId"],
                userToken: userDataExon["token"],
                firmaKodu: userDataExon["firmaKodu"],
                durum: durum,
                dil: "",
                baslangic: baslangic,
                limit: limit,
                serviceName: "hizmet",
                methodName: "hizmetListesi"

            }
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },
    hizmetDurumGuncelle(hizmetId, durum) {
        var userDataExon = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataExon"))));
        var param = {
            data: {
                yonetimId: userDataExon["yonetimId"],
                userToken: userDataExon["token"],
                firmaKodu: userDataExon["firmaKodu"],
                hizmetId: hizmetId,
                durum: durum,
                serviceName: "hizmet",
                methodName: "hizmetDurumGuncelle"

            }
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },
    hizmetGuncelle(hizmetId, updateList) {
        var userDataExon = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataExon"))));
        var param = {
            data: {
                yonetimId: userDataExon["yonetimId"],
                userToken: userDataExon["token"],
                firmaKodu: userDataExon["firmaKodu"],
                hizmetId: hizmetId,
                updateList: updateList,
                serviceName: "hizmet",
                methodName: "hizmetGuncelle"

            }
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },

}

export default hizmetService

